import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import Eatec from "../../../assets/img/Featured/tablet-eatec.png";
//import InfoGenesis from "../../../assets/img/Featured/kiosk-retail.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const BookStorePage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const InfoGenesis = "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/InfoGenesis3.png";
    return(
        <div className="page bookstorePage">
            <Header />
            <div className="page-header">Main Campus</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Gift Shop</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Maximize school spirit by keeping hats, hoodies, 
                    mugs, apparel, and accessories in stock at the 
                    right price for every student.{'\n\n'}

                    With InfoGenesis POS and Eatec procurement and 
                    perpetual inventory system, not only will you have 
                    the items your students desire, but they can also 
                    seamlessly pay by charging to their student 
                    card, credit cards, gift cards or cash.
                </div>

            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Main Campus - Book Store", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <img src={InfoGenesis} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Main Campus - Book Store", "Eatec");
                    addFlow("Eatec");
                    navigate("/solutions/eatec")}}>
                    <img src={Eatec} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Eatec
                    </div>
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default BookStorePage;